import { Truck, MessageCircle, PackageCheck } from "lucide-react";
import { ORDER_DELIVERY } from "@/lib/store";
import { OrderForm } from "./OrderForm";
import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  { icon: MessageCircle, text: "Você diz o que quer: modelo, cor, armazenamento ou do seu jeito." },
  { icon: PackageCheck, text: "A gente confirma valor, condição e parcelamento pelo WhatsApp." },
  { icon: Truck, text: "Entregamos em até 7 dias corridos — ou devolvemos seu dinheiro." },
];

export const OrderSection = () => (
  <section id="pedido" data-testid="order-section" className="mx-auto max-w-[1440px] px-5 sm:px-8 pb-24 sm:pb-36">
    <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
      <Reveal className="lg:col-span-5">
        <Eyebrow>Fazer pedido</Eyebrow>
        <h2 className="font-display mt-5 text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-[-0.04em] text-white leading-[0.95]">
          Não achou? <span className="text-outline">Encomende.</span>
        </h2>
        <p data-testid="order-delivery-note" className="mt-8 inline-flex items-start gap-2 rounded-2xl bg-white px-4 py-2.5 text-sm font-bold text-black">
          <Truck className="mt-0.5 h-4 w-4 shrink-0" /> {ORDER_DELIVERY}
        </p>
        <ol className="mt-10 space-y-5">
          {STEPS.map(({ icon: Icon, text }, i) => (
            <li key={text} className="flex items-start gap-4 border-t border-white/10 pt-5">
              <span className="font-display text-3xl font-extrabold text-white">{i + 1}</span>
              <span className="flex items-start gap-2 pt-1.5 text-zinc-300"><Icon className="mt-0.5 h-4 w-4 shrink-0 text-white" />{text}</span>
            </li>
          ))}
        </ol>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7">
        <OrderForm />
      </Reveal>
    </div>
  </section>
);
